import { render, staticRenderFns } from "./EditDomainForm.vue?vue&type=template&id=13dc665c&"
import script from "./EditDomainForm.vue?vue&type=script&lang=js&"
export * from "./EditDomainForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports